import React from 'react';

import { DeploymentFrequencyData } from 'src/components/pipelines/hooks/use-deployment-frequency';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../metric-cards/i18n';
import { MetricCard } from '../metric-cards/metric-card';
import { MessageWrapper } from '../metric-cards/styles';

import { AverageChart } from './average-chart';
import { averageColorAccessor, inclineValueComparator } from './utils';

type AverageDeploymentFrequencyProps = DeploymentFrequencyData & {
  environmentType?: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const AverageDeploymentFrequency: React.FC<
  AverageDeploymentFrequencyProps
> = ({ environmentType, ...props }) => {
  const { formatMessage } = useIntl();

  if (environmentType && environmentType !== 'production')
    return (
      <MetricCard label={formatMessage(messages.deploymentFrequencyTitle)}>
        <MessageWrapper>
          {formatMessage(messages.deploymentFrequencyNonProd)}
        </MessageWrapper>
      </MetricCard>
    );

  return (
    <AverageChart
      {...props}
      chartConfig={[
        {
          dataKey: 'frequency',
          colorAccessor: averageColorAccessor,
        },
      ]}
      tooltipConfig={[
        {
          dataAccessor: data => data?.frequency?.toLocaleString(),
          label: formatMessage(messages.frequency),
        },
      ]}
      chartValueComparator={inclineValueComparator}
      chartTitle={formatMessage(messages.deploymentFrequencyTitle)}
    />
  );
};
